export const reOrgNotificationConstants = {
	Create: {
		FAILURE : 'CREATE_REORG_NOTIFICATION_FAILURE',
		REQUEST : 'CREATE_REORG_NOTIFICATION_REQUEST',
		SUCCESS : 'CREATE_REORG_NOTIFICATION_SUCCESS'
	},
	Read: {
		FAILURE : 'READ_REORG_NOTIFICATION_FAILURE',
		REQUEST : 'READ_REORG_NOTIFICATION_REQUEST',
		SUCCESS : 'READ_REORG_NOTIFICATION_SUCCESS'
	},
	GetPaged: {
		FAILURE : 'GET_PAGED_REORG_NOTIFICATION_FAILURE',
		REQUEST : 'GET_PAGED_REORG_NOTIFICATION_REQUEST',
		SUCCESS : 'GET_PAGED_REORG_NOTIFICATION_SUCCESS'
	},
	GetPagedAll: {
		FAILURE : 'GET_PAGED_ALL_REORG_NOTIFICATION_FAILURE',
		REQUEST : 'GET_PAGED_ALL_REORG_NOTIFICATION_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_REORG_NOTIFICATION_SUCCESS'
	},
	DownloadFile: {
		FAILURE : 'DOWNLOAD_NOTIFICATION_FILE_FAILURE',
		REQUEST : 'DOWNLOAD_NOTIFICATION_FILE_REQUEST',
		SUCCESS : 'DOWNLOAD_NOTIFICATION_FILE_SUCCESS'
	},
	GetAny: {
		FAILURE : 'GET_ANY_NOTIFICATION_FAILURE',
		REQUEST : 'GET_ANY_NOTIFICATION_REQUEST',
		SUCCESS : 'GET_ANY_NOTIFICATION_SUCCESS'
	},
	CLEAR: 'CLEAR_REORG_NOTIFICATION'
}